import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_111: FaireProductEntity = {
  token: "catalog_prod_prod-111",
  type: "product",
  name: "Serving Piece - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 49.55,
  msrpDollars: 123.88,
  sku: "CA0111",
  caseSize: 6,
  material: "Glass",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 421,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_stationery-writing"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
